export function buildFullHtml({ title = 'Relatório', styles = '', bodyHtml = '' }) {
  const baseStyles = `
    @page { size: A4; margin: 12mm; }
    html, body { height: 100%; }
    body { font-family: Arial, sans-serif; color: #111827; margin: 0; background: #ffffff; }
    .print-container { padding: 0; }
    table { width: 100%; border-collapse: collapse; font-size: 11px; }
    th { text-align: left; padding: 6px; border-bottom: 1px solid #e5e7eb; }
    td { padding: 4px 6px; border-bottom: 1px solid #f3f4f6; }
    .report-header { display:flex; justify-content:space-between; align-items:center; padding: 12px 16px; border-bottom:2px solid #4a5568; }
    .report-footer { padding: 10px 16px; border-top: 1px solid #e5e7eb; margin-top: 12px; font-size: 12px; }
    .summary { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 12px 16px; }
    .summary .card { border: 1px solid #e5e7eb; border-radius: 6px; padding: 8px; }
    .section { margin: 10px 16px 0 16px; }
  `

  return `<!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>${title}</title>
      <style>${baseStyles}${styles}</style>
    </head>
    <body>
      <div class="print-container">${bodyHtml}</div>
      <script>
        window.onload = function() { try { window.print(); } catch(e){} };
      </script>
    </body>
  </html>`
}

export function openPrintWindow(html) {
  const printWindow = window.open('', '_blank')
  if (!printWindow) return
  printWindow.document.open()
  printWindow.document.write(html)
  printWindow.document.close()
}